import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.667 10.667a1 1 0 0 0 1-1 .5.5 0 0 0 0-.1l1.86-1.86h.306L8.907 8.78v.053a1 1 0 1 0 2 0V8.78l2.426-2.447a1 1 0 1 0-1-1 .5.5 0 0 0 0 .1L9.927 7.84H9.82L8.667 6.667a1 1 0 0 0-2 0l-2 2a1 1 0 0 0 0 2m9 2.666H2.333V2A.667.667 0 1 0 1 2v12a.667.667 0 0 0 .667.667h12a.667.667 0 0 0 0-1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })